var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclePattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "482px",
    height: "345px",
    viewBox: "0 0 482 345",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Circle Pattern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Images",
    strokeWidth: 1,
    fillRule: "evenodd",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-/-BG-Pattern-/-v2---White---25%",
    transform: "translate(-82.000000, -90.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-/-BG-Pattern-/-v1---Lindab-Blue---25%",
    transform: "translate(82.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9452265,258.861489 C34.0345446,136.765858 132.143097,37.8345826 254,35.9529846 L254,0 C112.846254,3.03636072 0,118.548274 0,260 C0,401.451726 112.846254,516.963639 254,520 L254,482.848583 C131.781452,480.829786 33.57915,381.324817 32.9452265,258.861489 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,259.46064 C139.957817,323.279416 190.348854,375.676984 254,378 L254,342.042661 C209.995209,340.357091 175.189023,304.123659 175.189023,260 C175.189023,215.876341 209.995209,179.642909 254,177.957339 L254,142 C190.575072,143.877464 140.101585,195.883161 140,259.46064 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6756,259.398734 C105.049669,175.8551 172.182211,107.836008 256,106.075949 L256,70 C153.338006,73.640407 72,157.63074 72,260 C72,362.36926 153.338006,446.359593 256,450 L256,413.924051 C171.768909,412.026435 104.52274,343.35783 104.6756,259.398734 L104.6756,259.398734 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,259.459372 C481.747804,137.039109 383.759861,37.5102915 262,36 L262,70.1196031 C366.277047,70.1196031 450.810296,155.105058 450.810296,259.93993 C450.810296,364.774802 366.277047,449.760257 262,449.760257 L262,484 C384.096576,482.290495 482.142492,382.220918 482,259.459372 L482,259.459372 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.326818,259.518374 C376.287984,324.010902 325.629511,376.77645 262,378.600469 L262,414 C345.947282,414 414,345.051851 414,260 C414,174.948149 345.947282,106 262,106 L262,141.279124 C325.36169,142.968008 375.963821,195.301818 376.326818,259.518374 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePattern);
export default __webpack_public_path__ + "static/media/circle-pattern.9afde409.svg";
export { ForwardRef as ReactComponent };